if (!customElements.get('kindra-customer-hub')) {
  customElements.define('kindra-customer-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.rows = [...this.querySelectorAll('[data-document]')];
      this.radios = [...this.querySelectorAll('[data-heater-selector] input[type="radio"]')];
      this.models = [...this.querySelectorAll('[data-model-selector] input[type="radio"]')];
      this.querySelector('[data-model-selector]').hidden = false;
      this.querySelector('[data-heater-selector]').hidden = false;
      this.addEventListener('change', event => {
        if (!this.radios.includes(event.target) && !this.models.includes(event.target)) return;
        const url = new URL(location.href);
        url.searchParams.set(this.models.includes(event.target) ? 'model' : 'heater', event.target.value);
        url.searchParams.delete('document');
        history.replaceState(null, '', url);
        this.update();
      }, options);
      this.addEventListener('click', async event => {
        const download = event.target.closest('a[download]');
        if (download && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          if (download.getAttribute('aria-busy') === 'true') return;
          download.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(download.href);
            if (!response.ok) throw new Error('Download unavailable');
            const objectURL = URL.createObjectURL(await response.blob());
            const link = document.createElement('a');
            link.href = objectURL;
            link.download = new URL(download.href).pathname.split('/').pop() || 'kindra-guide.pdf';
            document.body.append(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(objectURL), 60000);
          } catch { location.assign(download.href); }
          finally { download.removeAttribute('aria-busy'); }
          return;
        }
        const view = event.target.closest('[data-view-guide]');
        const back = event.target.closest('[data-all-guides]');
        if ((!view && !back) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        const url = new URL(location.href);
        if (view) url.searchParams.set('document', view.closest('[data-document]').dataset.document);
        else url.searchParams.delete('document');
        history.pushState(null, '', url);
        this.update(true);
      }, options);
      window.addEventListener('popstate', () => this.update(true), options);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    update(focus = false) {
      const url = new URL(location.href);
      const model = url.searchParams.get('model') === '4-6' ? '4-6' : '2-3';
      this.models.forEach(input => { input.checked = input.value === model; });
      this.querySelector('[data-large-model-notice]').hidden = model !== '4-6';
      this.querySelector('[data-large-viewer-notice]').hidden = model !== '4-6';
      this.querySelector('[data-small-model-card]').hidden = model === '4-6';
      const eyebrow = this.querySelector('[data-model-eyebrow]');
      if (!eyebrow.dataset.original) eyebrow.dataset.original = eyebrow.textContent;
      eyebrow.textContent = model === '4-6' ? 'Elata · 4–6 Person Sauna' : eyebrow.dataset.original;
      let saved;
      try { saved = localStorage.getItem('kindra-hub-heater'); } catch {}
      const requested = url.searchParams.get('heater');
      const heater = ['huum','harvia'].includes(requested) ? requested : (['huum','harvia'].includes(saved) ? saved : this.dataset.defaultHeater);
      try { localStorage.setItem('kindra-hub-heater', heater); } catch {}
      this.radios.forEach(input => { input.checked = input.value === heater; });
      this.rows.forEach(row => {
        row.hidden = (row.dataset.heater !== 'all' && row.dataset.heater !== heater) || (row.dataset.model !== 'all' && row.dataset.model !== model);
        const link = row.querySelector('[data-view-guide]');
        if (!link.dataset.pdf) link.dataset.pdf = link.href;
        const target = new URL(location.href);
        target.searchParams.set('document', row.dataset.document);
        target.searchParams.set('heater', heater);
        target.searchParams.set('model', model);
        link.href = target.href;
      });
      this.querySelectorAll('[data-guide-group]').forEach(group => { group.hidden = ![...group.querySelectorAll('[data-document]')].some(row => !row.hidden); });
      const selected = this.rows.find(row => !row.hidden && row.dataset.document === url.searchParams.get('document'));
      this.querySelector('[data-hub-home]').hidden = !!selected;
      this.querySelector('[data-hub-viewer]').hidden = !selected;
      const frame = this.querySelector('[data-pdf-frame]');
      const backURL = new URL(location.href);
      backURL.searchParams.delete('document');
      this.querySelector('[data-all-guides]').href = backURL.href;
      if (selected) {
        const title = selected.querySelector('[data-document-title]').textContent;
        const pdf = selected.querySelector('[data-view-guide]').dataset.pdf;
        this.querySelector('[data-viewer-title]').textContent = title;
        frame.title = title;
        if (frame.getAttribute('src') !== pdf + '#page=1') frame.src = pdf + '#page=1';
        this.querySelector('[data-viewer-download]').href = pdf;
        this.querySelector('[data-viewer-direct]').href = pdf;
        if (focus) this.querySelector('[data-viewer-title]').focus();
      } else { frame.removeAttribute('src'); if (focus) this.scrollIntoView({block:'start'}); }
    }
  });
}

